// UI Interface functions
import categoriesService from '../services/categoriesService.js';

const createUIInterface = () => {
  
  // Connection status management
  const setConnectionStatus = (status) => {
    const statusElement = document.getElementById('connection-status')
    const indicator = statusElement.querySelector('div')
    const text = statusElement.querySelector('span')
    
    // Remove all status classes
    indicator.classList.remove('status-connected', 'status-connecting', 'status-disconnected', 'status-pulse')
    
    switch (status) {
      case 'connected':
        indicator.classList.add('status-connected')
        text.textContent = 'Connesso a WordPress'
        break
      case 'connecting':
        indicator.classList.add('status-connecting', 'status-pulse')
        text.textContent = 'Connessione in corso...'
        break
      case 'disconnected':
        indicator.classList.add('status-disconnected')
        text.textContent = 'Non connesso'
        break
      default:
        indicator.classList.add('bg-gray-400')
        text.textContent = 'Stato sconosciuto'
    }
  }
  
  // Load configuration into form
  const loadConfiguration = (config) => {
    if (config.wpUrl) document.getElementById('wp-url').value = config.wpUrl
    if (config.username) document.getElementById('wp-username').value = config.username
    if (config.password) document.getElementById('wp-password').value = config.password
  }
  
  // Update statistics
  const updateStats = (stats) => {
    document.getElementById('stats-mangiare').textContent = stats.mangiare || 0
    document.getElementById('stats-dormire').textContent = stats.dormire || 0
    document.getElementById('stats-comprare').textContent = stats.comprare || 0
    const cv = document.getElementById('stats-vedere')
    if (cv) cv.textContent = stats['vedere'] || 0
    const ass = document.getElementById('stats-associazioni')
    if (ass) ass.textContent = stats.associazioni || 0
  }
  
  // Show/hide loading state
  const showLoading = (show) => {
    const loadingElement = document.getElementById('loading-activities')
    const tableElement = document.getElementById('activities-table')
    const emptyElement = document.getElementById('empty-state')
    
    if (show) {
      loadingElement.classList.remove('hidden')
      tableElement.classList.add('hidden')
      emptyElement.classList.add('hidden')
    } else {
      loadingElement.classList.add('hidden')
    }
  }
  
  // Show empty state
  const showEmptyState = (isFirstTime = false) => {
    const loadingElement = document.getElementById('loading-activities')
    const tableElement = document.getElementById('activities-table')
    const emptyElement = document.getElementById('empty-state')
    
    loadingElement.classList.add('hidden')
    tableElement.classList.add('hidden')
    emptyElement.classList.remove('hidden')
    
    const title = emptyElement.querySelector('h3')
    const description = emptyElement.querySelector('p')
    
    if (isFirstTime) {
      title.textContent = 'Nessuna attività trovata'
      description.textContent = 'Inizia aggiungendo la prima attività commerciale.'
    } else {
      title.textContent = 'Nessun risultato'
      description.textContent = 'Prova a modificare i filtri di ricerca.'
    }
  }
  
  // Render activities table
  const renderActivitiesTable = (activities, handlers) => {
    const loadingElement = document.getElementById('loading-activities')
    const tableElement = document.getElementById('activities-table')
    const emptyElement = document.getElementById('empty-state')
    const tbody = document.getElementById('activities-tbody')
    
    // Show table, hide others
    loadingElement.classList.add('hidden')
    tableElement.classList.remove('hidden')
    emptyElement.classList.add('hidden')
    
    // Clear existing rows
    tbody.innerHTML = ''
    
    // Generate table rows
    activities.forEach(activity => {
      const row = createActivityRow(activity, handlers)
      tbody.appendChild(row)
    })
  }
  
  // Create single activity row
  const createActivityRow = (activity, handlers) => {
    const row = document.createElement('tr')
    row.className = 'table-row animate-fade-in'
    
    // Category icons and colors - use categoriesService for dynamic lookup
    const category = categoriesService.getCategoryBySlug(activity.categoria);
    const catConfig = category
      ? { icon: category.icon, name: category.name, class: category.class }
      : { icon: '📋', name: 'Altro', class: 'badge-primary' };
    
    // Status badge
    const statusClass = activity.status === 'publish' ? 'badge-success' : 'badge-warning'
    const statusText = activity.status === 'publish' ? 'Pubblicata' : 'Bozza'

    // Translation status
    const isTranslation = activity.translation_of // Questo è un post traduzione
    const isOriginal = !isTranslation // Questo è un post originale
    const hasTranslation = activity.has_translation // Post originale con traduzione esistente

    row.innerHTML = `
      <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <div class="flex items-center justify-end space-x-2">
          <button
            onclick="editActivity(${JSON.stringify(activity).replace(/"/g, '&quot;')})"
            class="text-blue-600 hover:text-blue-900 p-1 rounded transition-colors"
            title="Modifica attività"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
          </button>
          ${isOriginal ? `
            <button
              onclick="translateActivity(${JSON.stringify(activity).replace(/"/g, '&quot;')})"
              class="text-green-600 hover:text-green-900 p-1 rounded transition-colors"
              title="${hasTranslation ? 'Modifica traduzione inglese' : 'Traduci in inglese'}"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"></path>
              </svg>
            </button>
          ` : ''}
          <button
            onclick="deleteActivity(${activity.id})"
            class="text-red-600 hover:text-red-900 p-1 rounded transition-colors"
            title="Elimina attività"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </button>
        </div>
      </td>
      <td class="px-6 py-4 whitespace-nowrap">
        <div class="flex items-center">
          <div class="flex-shrink-0 h-12 w-12">
            ${activity.immagine_principale ? 
              `<img class="h-12 w-12 rounded-lg object-cover" src="${activity.immagine_principale}" alt="${activity.nome}" onerror="this.src='data:image/svg+xml,<svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;48&quot; height=&quot;48&quot; viewBox=&quot;0 0 24 24&quot; fill=&quot;%23e5e7eb&quot;><path d=&quot;M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V5h14v14H5z&quot;/><path d=&quot;M13.96 12.71l-2.12-2.12a1 1 0 0 0-1.42 0l-4.13 4.13V19h14v-4.29l-6.33-6.33z&quot;/></svg>'" />` :
              `<div class="h-12 w-12 rounded-lg bg-gray-200 flex items-center justify-center text-gray-400 text-lg">${catConfig.icon}</div>`
            }
          </div>
          <div class="ml-4">
            <div class="text-sm font-medium text-gray-900 max-w-xs truncate" title="${activity.nome}">
              ${activity.nome}
              ${isTranslation ? '<span class="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">🌐 EN</span>' : ''}
              ${hasTranslation && isOriginal ? '<span class="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">✓ EN</span>' : ''}
            </div>
            <div class="text-sm text-gray-500 max-w-xs truncate" title="${activity.descrizione || ''}">
              ${activity.descrizione ? (activity.descrizione.substring(0, 60) + (activity.descrizione.length > 60 ? '...' : '')) : 'Nessuna descrizione'}
            </div>
          </div>
        </div>
      </td>
      <td class="px-6 py-4 whitespace-nowrap">
        <span class="badge ${catConfig.class}">
          ${catConfig.icon} ${catConfig.name}
        </span>
      </td>
      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        <div class="space-y-1">
          ${activity.telefono ? `<div class="flex items-center text-xs"><span class="mr-1">📞</span>${activity.telefono}</div>` : ''}
          ${activity.email ? `<div class="flex items-center text-xs"><span class="mr-1">✉️</span>${activity.email}</div>` : ''}
          ${activity.indirizzo ? `<div class="flex items-center text-xs"><span class="mr-1">📍</span>${activity.indirizzo}</div>` : ''}
        </div>
      </td>
      <td class="px-6 py-4 whitespace-nowrap">
        <span class="badge ${statusClass}">${statusText}</span>
        <div class="text-xs text-gray-500 mt-1">
          Aggiornata: ${formatDate(activity.modified)}
        </div>
      </td>
    `
    
    return row
  }
  
  // Render image preview with remove (X) button
  const renderImagePreview = (src) => {
    if (!src) return ''
    return `
      <div class="relative inline-block">
        <img src="${src}" alt="preview" class="h-24 w-24 object-cover rounded"/>
        <button type="button" id="remove-image-btn" title="Elimina immagine"
          class="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-red-600 hover:bg-red-700 text-white text-xs shadow">
          ✕
        </button>
      </div>
    `
  }

  // Render gallery previews, each with a remove (X) button
  const renderGalleryPreview = (urls) => {
    return (urls || [])
      .map((u, i) => `
        <div class="relative inline-block mr-2 mb-2">
          <img src="${u}" alt="gallery" class="h-20 w-20 object-cover rounded"/>
          <button type="button" data-gallery-remove="${i}" title="Elimina immagine"
            class="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-red-600 hover:bg-red-700 text-white text-xs shadow">
            ✕
          </button>
        </div>
      `)
      .join('')
  }

  // Populate activity form for editing
  const populateActivityForm = (activity) => {
    document.getElementById('activity-name').value = activity.nome || ''
    document.getElementById('activity-category').value = activity.categoria || ''
    document.getElementById('activity-phone').value = activity.telefono || ''
    document.getElementById('activity-email').value = activity.email || ''
    document.getElementById('activity-address').value = activity.indirizzo || ''
    document.getElementById('activity-website').value = activity.sito_web || ''
    document.getElementById('activity-facebook').value = activity.facebook || ''
    document.getElementById('activity-instagram').value = activity.instagram || ''
    document.getElementById('activity-description').value = activity.descrizione || ''
    document.getElementById('activity-hours').value = activity.orari || ''
    // Reset file inputs
    const imageInput = document.getElementById('activity-image-file')
    if (imageInput) imageInput.value = ''
    const galleryInput = document.getElementById('activity-gallery-files')
    if (galleryInput) galleryInput.value = ''
    // Previews
    const imagePrev = document.getElementById('activity-image-preview')
    const galleryPrev = document.getElementById('activity-gallery-preview')
    if (imagePrev) {
      imagePrev.innerHTML = renderImagePreview(activity.immagine_principale)
    }
    if (galleryPrev) {
      const items = (activity.galleria || '')
        .split(/\n|,/)
        .map(u => u.trim())
        .filter(Boolean)
      galleryPrev.innerHTML = renderGalleryPreview(items)
    }
  }
  
  // Generate CSV content
  const generateCSV = (activities) => {
    const headers = [
      'Nome',
      'Categoria', 
      'Descrizione',
      'Telefono',
      'Email',
      'Indirizzo',
      'Sito Web',
      'Facebook',
      'Instagram',
      'Orari',
      'Immagine Principale',
      'Galleria',
      'Status',
      'Data Creazione',
      'Ultima Modifica'
    ]
    
    const rows = activities.map(activity => [
      `"${activity.nome || ''}"`,
      `"${activity.categoria || ''}"`,
      `"${(activity.descrizione || '').replace(/"/g, '""')}"`,
      `"${activity.telefono || ''}"`,
      `"${activity.email || ''}"`,
      `"${activity.indirizzo || ''}"`,
      `"${activity.sito_web || ''}"`,
      `"${activity.facebook || ''}"`,
      `"${activity.instagram || ''}"`,
      `"${(activity.orari || '').replace(/"/g, '""')}"`,
      `"${activity.immagine_principale || ''}"`,
      `"${(activity.galleria || '').replace(/"/g, '""')}"`,
      `"${activity.status || ''}"`,
      `"${activity.created || ''}"`,
      `"${activity.modified || ''}"`
    ])
    
    return [headers.join(','), ...rows.map(row => row.join(','))].join('\n')
  }
  
  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return ''
    
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString('it-IT', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    } catch (error) {
      return dateString
    }
  }
  
  // Form validation visual feedback
  const setFieldValidation = (fieldId, isValid, message = '') => {
    const field = document.getElementById(fieldId)
    const parent = field.parentElement
    
    // Remove existing validation classes
    field.classList.remove('input-error', 'input-success')
    
    // Remove existing error message
    const existingError = parent.querySelector('.validation-message')
    if (existingError) {
      existingError.remove()
    }
    
    if (isValid) {
      field.classList.add('input-success')
    } else {
      field.classList.add('input-error')
      
      if (message) {
        const errorDiv = document.createElement('div')
        errorDiv.className = 'validation-message text-sm text-danger-600 mt-1'
        errorDiv.textContent = message
        parent.appendChild(errorDiv)
      }
    }
  }
  
  // Clear all form validation
  const clearFormValidation = () => {
    const form = document.getElementById('activity-form')
    const fields = form.querySelectorAll('input, textarea, select')
    
    fields.forEach(field => {
      field.classList.remove('input-error', 'input-success')
    })
    
    const errorMessages = form.querySelectorAll('.validation-message')
    errorMessages.forEach(msg => msg.remove())
  }
  
  // Animate elements
  const animateElement = (element, animationClass) => {
    element.classList.add(animationClass)
    
    // Remove animation class after animation completes
    setTimeout(() => {
      element.classList.remove(animationClass)
    }, 300)
  }
  
  // Progressive loading for large datasets
  const renderActivitiesProgressive = (activities, handlers, batchSize = 20) => {
    const tbody = document.getElementById('activities-tbody')
    tbody.innerHTML = ''
    
    let currentIndex = 0
    
    const renderBatch = () => {
      const batch = activities.slice(currentIndex, currentIndex + batchSize)
      
      batch.forEach((activity, index) => {
        setTimeout(() => {
          const row = createActivityRow(activity, handlers)
          tbody.appendChild(row)
          animateElement(row, 'animate-slide-in')
        }, index * 50) // Stagger animation
      })
      
      currentIndex += batchSize
      
      if (currentIndex < activities.length) {
        setTimeout(renderBatch, 100)
      }
    }
    
    // Show table and start rendering
    const loadingElement = document.getElementById('loading-activities')
    const tableElement = document.getElementById('activities-table')
    const emptyElement = document.getElementById('empty-state')
    
    loadingElement.classList.add('hidden')
    tableElement.classList.remove('hidden')
    emptyElement.classList.add('hidden')
    
    renderBatch()
  }
  
  return {
    setConnectionStatus,
    loadConfiguration,
    updateStats,
    showLoading,
    showEmptyState,
    renderActivitiesTable,
    renderActivitiesProgressive,
    populateActivityForm,
    renderImagePreview,
    renderGalleryPreview,
    generateCSV,
    setFieldValidation,
    clearFormValidation,
    animateElement,
    formatDate
  }
}

export const ui = createUIInterface()